import React, { useState } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import ConfirmDialog from './ConfirmDialog';

export default function useDiscardChanges(en) {
  const [pending, setPending] = useState(null);
  const request = (action, message) => setPending({ action, message });
  const dialog = <ConfirmDialog open={!!pending} className="discard-changes-dialog"
    title={<><span className="discard-changes-icon"><FiAlertTriangle /></span>{en ? 'Discard unsaved changes?' : 'Bỏ thay đổi chưa lưu?'}</>}
    message={pending?.message || (en ? 'Your changes have not been saved. Continue editing to keep your work.' : 'Các thay đổi chưa được lưu. Bạn có thể tiếp tục chỉnh sửa để giữ lại thông tin đang nhập.')}
    cancelText={en ? 'Continue editing' : 'Tiếp tục chỉnh sửa'} confirmText={en ? 'Discard changes' : 'Bỏ thay đổi'}
    onCancel={() => setPending(null)} onConfirm={() => { const action = pending?.action; setPending(null); action?.(); }} />;
  return [request, dialog];
}
